import React from 'react'
import '../Footer/Footer.css'

function Footer() {
  return (
    <div className='footer'>
      <p>
        © Rodney Todd SWE General Assembly
      </p>
    </div>
  )
}

export default Footer
